import React, { useState } from 'react';
import { useMutation } from 'react-query';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {
    searchAdminUser,
    resetUserPassword
} from '../../../api/apiServices';
import toast, { Toaster } from 'react-hot-toast'
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import UserRoles from '../../../hooks/userRoles';
import useAuth from "../../../hooks/useAuth";
import jwt_decode from "jwt-decode";

const ResetUserPassword = () => {
    const { auth } = useAuth();
    const decoded = auth?.accessToken
        ? jwt_decode(auth.accessToken)
        : undefined

    const role = decoded?.UserInfo?.role || ""


    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    const [search, setSearch] = useState(false);
    const [adminUser, setAdminUser] = useState([]);
    const [email, setEmail] = useState("");
    const [mobile_number, setMobileNumber] = useState("");
    const [first_name, setFirstName] = useState("");
    const [last_name, setLastName] = useState("");

    const handleSearch = async (e) => {
        e.preventDefault();
        const searchData = {
            email: email,
            mobile_number: mobile_number,
            first_name: first_name,
            last_name: last_name,
        }
        searchMutation.mutate(searchData)
    }

    const searchMutation = useMutation(searchAdminUser, {
        onSuccess: async (res) => {
            if (res.status) {
                setAdminUser(res.admin_user)
                setSearch(true)
            } else {
                toast.error(res.message, {
                    duration: 5000,
                    className: "toast-message"
                })
                setAdminUser([])
                setSearch(false)
            }
        },
        onError: async (err) => {
            toast.error(err.message, {
                duration: 5000,
                className: "toast-message"
            })
        }
    })
    const handleResetPswd = (id) => {
        if (role === UserRoles.SuperAdmin || role === UserRoles.SystemAdmin) {
            resetPasswordMutation.mutate(id)
        } else {
            toast.error("You are not authorized to perform this function. Contact the System Administrator", {
                duration: 3000,
                className: "toast-message"
            });
            return false
        }
    }

    const resetPasswordMutation = useMutation(resetUserPassword, {
        onSuccess: async (res) => {
            if (res.status) {
                toast.success(res.message, {
                    duration: 5000,
                    className: "toast-message"
                })
                setSearch(false)
                setEmail("")
                setMobileNumber("")
                setFirstName("")
                setLastName("")
            } else {
                toast.error(res.message, {
                    duration: 5000,
                    className: "toast-message"
                })
                setSearch(false)
                setEmail("")
                setMobileNumber("")
                setFirstName("")
                setLastName("")
            }
        },
        onError: async (err) => {
            toast.error(err.message, {
                duration: 5000,
                className: "toast-message"
            })
        }
    })

    const handleCancel = () => {
        setSearch(false)
        setEmail("")
        setMobileNumber("")
        setFirstName("")
        setLastName("")
    }

    let searchContent = (
        <form onSubmit={handleSearch} >
            <div className="form-group row">
                <div className="col-sm-3">
                    <input
                        className="form-control"
                        type="text"
                        placeholder="Email"
                        style={{ textTransform: "uppercase" }}
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                    />
                </div>
                <div className="col-sm-3">
                    <PhoneInput
                        id="mobile_number"
                        inputStyle={{ width: '100%', height: "34px" }}
                        country={"gh"}
                        enableSearch={true}
                        value={mobile_number}
                        name="mobile_number"
                        onChange={(mobile_number) => setMobileNumber(mobile_number)}
                    />
                </div>
                <div className="col-sm-2">
                    <input
                        className="form-control"
                        type="text"
                        placeholder="FirstName"
                        style={{ textTransform: "uppercase" }}
                        onChange={(e) => setFirstName(e.target.value)}
                        value={first_name}
                    />
                </div>
                <div className="col-sm-2">
                    <input
                        className="form-control"
                        type="text"
                        placeholder="LastName"
                        style={{ textTransform: "uppercase" }}
                        onChange={(e) => setLastName(e.target.value)}
                        value={last_name}
                    />
                </div>
                <div className="col-sm-2">
                    <button
                        type="submit"
                        className="btn btn-success btn-block"
                    > <i className="fa fa-search"></i> Search User</button>
                </div>
            </div>
        </form>
    )

    const content = !search && adminUser?.length <= 0 ?
        <div className="table-responsive lg">
            <table className="table table-bordered">
                <tbody>
                    <tr>
                        <td style={{ fontSize: "20px", fontWeight: "700", color: "#000", textAlign: "center" }}>
                            No User found with the requested parameter(s)
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        : search && adminUser?.length > 0 ?
            <div className='table-responsive lg'>
                <table className="table table-borderless table-hover table-striped">
                    <thead className="align">
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Username</th>
                            <th scope="col">Full Name</th>
                            <th scope="col">Role</th>
                            <th scope="col">Mobile Number</th>
                            <th scope="col">Email</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {adminUser?.map((mem, index) =>
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{mem.username.toLocaleUpperCase()}</td>
                                <td style={{ whiteSpace: 'nowrap' }}>{mem.first_name.toLocaleUpperCase()} {mem.middle_name.toLocaleUpperCase()} {mem.last_name.toLocaleUpperCase()}</td>

                                <td style={{ whiteSpace: 'nowrap' }}>{mem.role?.role_name.toLocaleUpperCase()}</td>
                                <td style={{ whiteSpace: 'nowrap' }}>{mem.mobile_number}</td>
                                <td>{mem.email}</td>
                                <td style={{ whiteSpace: 'nowrap' }}>
                                    <div style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
                                        <Link onClick={() => handleResetPswd(mem.id)} className="small"><i className='fa fa-edit'></i> Reset Password</Link>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            : null

    return (
        <>
            <section className="content-header">
                <Toaster toastOptions={{ position: "top-center" }} />
                <h1>User Password Resetting</h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        {searchContent}
                                    </div>
                                </div>
                            </div>
                            {search ?
                                <>
                                    <div className="panel-body">
                                        {content}
                                    </div>
                                    <div className="panel-footer">
                                        <button className="btn btn-danger" onClick={handleCancel}>Cancel</button>
                                    </div>
                                </>
                                :
                                null}

                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default ResetUserPassword;
